{
  "purchaseRequest": {
    "title": "Purchase Requests",
    "subtitle": "Internal material requisitions raised ahead of purchase order generation.",
    "add": "New Purchase Request",
    "submit": "Submit",
    "approve": "Approve",
    "reject": "Reject",
    "closeHint": "Close this PR — it will stop appearing as a selectable dependency in the Purchase Order screen's PR picker.",
    "table": {
      "number": "PR Number", "warehouse": "Warehouse", "requestedBy": "Requested By", "date": "Date", "lines": "Lines", "status": "Status", "actions": "Actions",
      "material": "Material", "requestedQty": "Requested Qty", "remarks": "Remarks"
    }
  },
  "purchaseOrder": {
    "title": "Purchase Orders",
    "subtitle": "Formal purchase orders issued against suppliers.",
    "add": "New Purchase Order",
    "approve": "Approve",
    "reject": "Reject",
    "closeHint": "Close this PO — it will stop appearing as a selectable dependency in Gate Entry/GRN even though it wasn't fully received.",
    "table": {
      "number": "PO Number", "supplier": "Supplier", "warehouse": "Warehouse", "date": "Order Date", "value": "Total Value", "status": "Status", "actions": "Actions",
      "material": "Material", "orderedQty": "Ordered Qty", "unitPrice": "Unit Price", "receivedQty": "Received Qty", "lineValue": "Line Value"
    }
  },
  "gateEntry": {
    "title": "Gate Entries",
    "subtitle": "Vehicle and inward document log at the security gate.",
    "add": "New Gate Entry",
    "closeHint": "Close this gate entry — it will stop appearing as a selectable dependency in GRN even though it wasn't fully received.",
    "table": {
      "number": "Gate Entry #", "vehicle": "Vehicle No", "driver": "Driver", "po": "Linked PO", "entry": "Entry Time", "status": "Status", "actions": "Actions",
      "material": "Material", "qty": "Qty", "receivedQty": "Received Qty", "remarks": "Remarks"
    }
  },
  "form": {
    "warehouse": "Warehouse",
    "supplier": "Supplier",
    "material": "Material",
    "quantity": "Quantity",
    "unitPrice": "Unit Price",
    "remarks": "Remarks",
    "addLine": "Add Line",
    "vehicleNo": "Vehicle No",
    "driverName": "Driver Name",
    "inwardDocNo": "Inward Doc No",
    "linkedPR": "From Purchase Request (optional)",
    "linkedPO": "From Purchase Order (optional)",
    "items": "Items",
    "none": "None"
  },
  "view": "View",
  "edit": "Edit",
  "save": "Save",
  "cancel": "Cancel",
  "deleteConfirm": { "message": "This record will be permanently removed." }
}
